import type { Experience } from "../../types/experience";

interface ExperienceItemProps {
  item: Experience;
}

function ExperienceItem({ item }: ExperienceItemProps) {
  return (
    <div className="experience-item">
      <div className="experience-top">
        <div>
          <h3>{item.role}</h3>
          <p className="experience-company">{item.company}</p>
        </div>
        <span className="experience-meta">
          {item.dateRange}
          {item.location ? ` · ${item.location}` : ""}
        </span>
      </div>
      <p className="experience-description">{item.description}</p>
    </div>
  );
}

export default ExperienceItem;
